import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const modalStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxStyle: {
      position: 'absolute' as 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      maxHeight: '70vh',
      overflowY: 'auto',
      backgroundColor: '#FFFFFF',
      border: '2px solid #000',
      boxShadow: '24',
      padding: 40,
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    mt1: {
      marginTop: '1rem',
    },
    mb1: {
      marginBottom: '1rem',
    },
    ml1: {
      marginLeft: '1rem',
    },
    mr1: {
      marginRight: '1rem',
    },
    policyBody: {
      flex: 1,
      flexDirection: 'column',
      height: 'inherit',
      overflow: 'hidden',
      padding: 10,
    },
    footer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: 10,
      '& button': {
        marginLeft: '1rem',
      },
    },
  }),
);

export { modalStyles };
